import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusinessPartner } from '../../../model/business_partner';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LocalizedDatePipe } from '../../core/localized-date.pipe';
import { CopilotApiService } from '../../../services/copilot-api-service';
import { ToastService } from '../../../services/toast.service';
import { BusinessPartnersService } from '../../../common/services/business-partners.service';
import { AddBusinessPartnerDialog } from '../dialog/add-business-partner-dialog';

@Component({
  selector: 'app-business-partner-card',
  standalone: true,
  imports: [CommonModule, TranslateModule, LocalizedDatePipe, AddBusinessPartnerDialog],
  templateUrl: './business-partner-card.html',
  styleUrl: './business-partner-card.css'
})
export class BusinessPartnerCard {
  @Input({ required: true }) partner!: BusinessPartner;
  updating: boolean = false;
  showEditDialog: boolean = false;
  submittingEdit: boolean = false;
  @Output() updated = new EventEmitter<void>();

  constructor(
    private api: CopilotApiService,
    private toast: ToastService,
    private translate: TranslateService,
    private partnersService: BusinessPartnersService
  ) {}

  toggleEnabled(): void {
    if (!this.partner || this.partner.Id == null || this.updating) return;
    const next = !this.partner.Enabled;
    this.updating = true;
    this.api.updateBusinessPartner({ Id: this.partner.Id, Enabled: next }).subscribe({
      next: () => {
        this.partner.Enabled = next;
        if (this.partner.Id != null) {
          this.partnersService.setPartnerEnabled(this.partner.Id, next);
        }
        this.toast.success(this.translate.instant('business_partners.toggle_success'), 2000);
        this.updating = false;
      },
      error: () => {
        this.toast.error(this.translate.instant('business_partners.toggle_error'), 2000);
        this.updating = false;
      }
    });
  }

  openEditDialog(): void {
    this.showEditDialog = true;
    this.submittingEdit = false;
  }
  closeEditDialog(): void {
    this.showEditDialog = false;
    this.submittingEdit = false;
  }
  onSubmitEdit(form: { Id?: number | null; Name: string; LastName: string; Email: string; Phone: string; CompanyName: string; }): void {
    const id = this.partner?.Id;
    if (id == null) {
      this.toast.error(this.translate.instant('business_partners.toggle_error'), 2000);
      this.closeEditDialog();
      return;
    }
    this.submittingEdit = true;
    this.api.updateBusinessPartnerDetails({
      Id: id,
      Name: form.Name,
      LastName: form.LastName,
      Email: form.Email,
      Phone: form.Phone,
      CompanyName: form.CompanyName
    }).subscribe({
      next: () => {
        this.partnersService.refresh();
        this.updated.emit();
        this.submittingEdit = false;
        this.closeEditDialog();
      },
      error: () => {
        this.submittingEdit = false;
        this.closeEditDialog();
      }
    });
  }
}


